import { DIVISION_KINDS, LOANREQUEST_BUCKETS } from 'cpool-constants';
import { divisionId, divisionName, divisionPhoneNumberId, schemaId } from 'cpool-schemas';
import { z } from 'zod';

export const DivisionsTableDefinitionZod = z.object({
    // the aggregateId is a UUID; `id` is the human-readable 6 character handle and stays the primary key
    aggregateId: schemaId,
    buckets: z.array(z.nativeEnum(LOANREQUEST_BUCKETS)),
    corporationId: schemaId,
    deactivated: z.boolean().default(false),
    divisionLeaderId: schemaId.nullable(),
    // each id non-null only while that own template is activated, else standard (pickHeaderFooter)
    footerTemplateId: schemaId.nullable().default(null),
    headerTemplateId: schemaId.nullable().default(null),
    id: divisionId,
    kind: z.nativeEnum(DIVISION_KINDS),
    name: divisionName,
    phoneNumberId: divisionPhoneNumberId.nullish(),
});

export type DivisionsTableSchema = z.infer<typeof DivisionsTableDefinitionZod>;
